import React, { useState, useEffect } from 'react';
import { getCaseStatus } from '../../../../item/ItemRecruitmentContractorStatus';
import { SingleText, SingleInput } from '../../Res/BaseInput';
import { ContentBox } from '../ContentBox';
import { ReqRecruitmentContractorCaseInfo, VIEW_CASESTATUS1, CASE_STATUS_ONBOARD, CASE_STATUS_RESERVE } from '../../../../item/ItemRecruitmentContractor';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { DatePickerInput } from 'rc-datepicker';
import moment from 'moment';
import { getOnlyDate } from '../../../../item/ItemTools';
import { toRevise } from './ReviseSOPTools';

/**
 * 從“已上工” 改為 “預定中”
 * @param {*} param0 
 */
export function ReviseOnBoard2Reserve({ item, action, vw_status, setIsLoading }) {
    const [mItem, setItem] = useState({})

    const [caseComment, setCaseComment] = useState("")

    const description = "從“已上工” 改為 “預定中”"

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            // console.log(item)
            setItem(item)
            var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
            mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
            // console.log(mReqRecruitmentContractorCaseInfo)
            var cs = getCaseStatus(item, mReqRecruitmentContractorCaseInfo)
            // console.log(cs)
        }
    }, [item])

    function toCancel() {
        action(VIEW_CASESTATUS1)
    }

    function toAction() {
        toRevise(mItem, "已修改為預定中", {
            setIsLoading,
            description: getOnlyDate() + " 改為“預定中”",
            comment: caseComment,
            caseOnBoardDate: "",
            caseStatus: CASE_STATUS_RESERVE,
            isClosed: 0
        })
    }

    var superTitle = description
    var title = ""
    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    {vw_status}
                    <div className="col-md-3">
                        <p className="col-md-12">
                        務必自行追蹤，該員的加保情況！</p>
                        <p className="col-md-12">
                        務必自行追蹤被影響的其他派遣案件。</p>
                    </div>
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleInput title={"本次作業的評論/備註"} val={caseComment} action={setCaseComment} placeholder={"請儘量簡短"} size={6} />
                </div>
            </div>
        </>

    var footer =
        <div className="row text-right ">
            <div className="col-sm-12">
                <CancelSubmitButton cancelAction={toCancel} submitName={"確定"} submitAction={toAction} isRight={true} />
            </div>
        </div>

    return (
        <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    )
}